
import Swiper from "swiper";
import { Navigation } from "swiper/modules";

jQuery(($) => {

    if ($(".project-gallery--slider")) {
        new Swiper(".project-gallery--slider", {
            modules: [Navigation],
            spaceBetween: 30,
            speed: 750,
            slidesPerView: 'auto',
            navigation: {
                nextEl: ".project-gallery--slider-button-next",
                prevEl: ".project-gallery--slider-button-prev",
            },
            breakpoints: {
                320: {
                  spaceBetween: 20
                },
                640: {
                  spaceBetween: 25
                },
                1024: {
                    spaceBetween: 30,
                }
            }
        });
    }
})